<script setup>
defineProps({
	title: { type: String, required: true },
	modelValue: { type: Boolean, required: true }, // collapsed
	visible: { type: Boolean, default: true },
	tableDisplay: { type: Boolean, default: false } // matches old tnt-flag-table -> display:table vs block
});

defineEmits(['update:modelValue']);
</script>

<template>
	<template v-if="visible">
		<h3
			class="tnt-section-title tnt-collapsible"
			:class="{ 'tnt-collapsed': modelValue }"
			style="display: block"
			@click="$emit('update:modelValue', !modelValue)"
		>
			{{ title }}
		</h3>
		<div v-show="!modelValue">
			<slot />
		</div>
	</template>
</template>
